import { globalLoggerToken } from "@/tokens";
import { applyTransaction } from "@datorama/akita";
import { catchError, finalize, tap } from "rxjs";
import { inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { WishlistsApiService } from "../api_services/WishlistsApiService/WishlistsApiService";
import WishlistsBackInStockItemsStore from "../stores/WishlistsBackInStockItemsStore";

export type getBackInStockWishlistItemsParams = {
    productId: number;
    variantId: number;
    date: string;
}[];

@singleton()
class WishlistsBackInStockItemsService {
    constructor(
        private readonly wishlistsBackInStockItemsStore: WishlistsBackInStockItemsStore,
        private readonly wishlistsApiService: WishlistsApiService,
        @inject(globalLoggerToken) private readonly logger: LoggerInterface
    ) {}

    getBackInStockWishlistItems(params: getBackInStockWishlistItemsParams) {
        this.logger.debug(
            "WishlistsBackInStockItemsService.getBackInStockWishlistItems is started"
        );
        this.wishlistsBackInStockItemsStore.setLoading(true);

        return this.wishlistsApiService
            .getBackInStockWishlistItems(params)
            .pipe(
                finalize(() => {
                    this.wishlistsBackInStockItemsStore.setLoading(false);
                }),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "WishlistsBackInStockItemsService.getBackInStockWishlistItems is errored",
                        { error }
                    );
                    this.wishlistsBackInStockItemsStore.setError(true);
                    throw error;
                }),
                tap((items) => {
                    this.logger.debug(
                        "WishlistsBackInStockItemsService.getBackInStockWishlistItems is ready"
                    );

                    applyTransaction(() => {
                        this.wishlistsBackInStockItemsStore.update({
                            items,
                        });
                    });
                })
            );
    }
}

export default WishlistsBackInStockItemsService;
